export enum ItemAttributeAllowedValueTypeEnum {
  Strict = 'strict',
  RangeOfNumbers = 'rangeOfNumbers',
  Regexp = 'regexp',
}
